import { render, staticRenderFns } from "./kids_check.vue?vue&type=template&id=279285d8&"
import script from "./kids_check.vue?vue&type=script&lang=js&"
export * from "./kids_check.vue?vue&type=script&lang=js&"
import style0 from "./kids_check.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports